import { apiTransport as router } from './transport';
import { getContext } from './core';
import type { QueryFilters } from './transport';

export type SystemHealthExceptionQueueItemDto = {
  id: string;
  partition: 'system_health';
  title: string;
  detail: string;
  severity: 'Critical' | 'High' | 'Medium';
  route: string;
  resolvableViaGovernance: boolean;
  findingType: string;
  fingerprint: string;
  entityId: string;
  entityType: string;
};

export const systemHealthApi = {
  integrityExceptions: {
    list: async (filters?: { operatingOrganizationId?: string }) => {
      const context = getContext();
      const q: QueryFilters | undefined =
        filters?.operatingOrganizationId != null && filters.operatingOrganizationId !== ''
          ? { operatingOrganizationId: filters.operatingOrganizationId }
          : undefined;
      return router.get<SystemHealthExceptionQueueItemDto[]>('/system/integrity-exceptions', context, q);
    },
  },
  integrityAcknowledgements: {
    batch: async (body: {
      findingType: string;
      resolutionReason: string;
      batchId?: string;
      impactSummary?: string;
      operatingOrganizationId?: string;
      impactedRows: { entityId: string; fingerprint: string }[];
    }) => {
      const context = getContext();
      return router.post<{ id: string; eventTimestamp: string }>(
        '/system/integrity-acknowledgements/batch',
        body,
        context,
      );
    },
    single: async (body: {
      findingType: string;
      resolutionReason: string;
      entityId: string;
      fingerprint: string;
      impactSummary?: string;
      operatingOrganizationId?: string;
    }) => {
      const context = getContext();
      return router.post<{ id: string; eventTimestamp: string }>(
        '/system/integrity-acknowledgements',
        body,
        context,
      );
    },
  },
};
